// extracted by mini-css-extract-plugin
export default {"navTags":"NavDesktop_navTags__ljYgn","navLinks":"NavDesktop_navLinks__oJhG8","navLogo":"NavDesktop_navLogo__XPOW8","navBar":"NavDesktop_navBar__wzQ6Z"};